
export default {
  name: 'ExpandContact',
  props: {
    setting: {
      type: Object,
      default: () => {}
    },
    isShop: {
      type: Boolean,
      default: false
    }
  }
}
